"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FixtermOffer {
    constructor(active, contractLength, inquiryType, mileageYearly, mileageMonthly, monthlyPrice, subscriptionOfferId, priceOfferId) {
        this.active = active;
        this.contractLength = contractLength;
        this.inquiryType = inquiryType;
        this.mileageYearly = mileageYearly;
        this.mileageMonthly = mileageMonthly;
        this.monthlyPrice = monthlyPrice;
        this.subscriptionOfferId = subscriptionOfferId;
        this.priceOfferId = priceOfferId;
    }
}
exports.default = FixtermOffer;
